import i18n from "@swa-ui/locale";
import { yup } from "@swa-ui/object";

export const STREET_ADDRESS_MAX_LENGTH = 40;

export const STREET_ADDRESS_SCHEMA_FIELD_NAME = "street";

export const getStreetAddressFormFieldSchema = (label = i18n("StreetAddressFormField__LABEL")) =>
  yup
    .string()
    .trim()
    .required()
    .alphaNumericHashtagHyphenPeriodSpace()
    .max(STREET_ADDRESS_MAX_LENGTH)
    .label(label.toLowerCase());
